import {cn} from "@/lib/utils";
import { cva } from "class-variance-authority";

interface SectionTitle {
    title: string;
    className?: string;
    variant?: "normal" | "playfairDisplay";
    size?: "small" | "normal";
    skin?: "normal" | "muted" | "rose" | "bleuMarine" | "jaune" | "rouge" | "bleuCiel";
}

const variants = cva("", {
    variants: {
        variant: {
            normal: "font-exo-medium",
            playfairDisplay: "font-playfair-display-italic font-bold",
        },
        size: {
            small: "text-xl",
            normal: "text-3xl"
        },
        skin: {
            normal: "",
            muted: "text-muted-foreground",
            rose: "text-rose",
            bleuMarine: "text-bleu-marine",
            jaune: "text-jaune",
            rouge: "text-rouge",
            bleuCiel: "text-bleu-ciel"
        }
    },
    defaultVariants: {
        variant: "normal",
        size: "normal",
        skin: "normal"
    }
});

export default function SectionTitle({title, className, variant, size, skin}: Readonly<SectionTitle>) {
    return (
        <h2 className={cn(variants({variant, size, skin}), className)}>{title}</h2>
    )
}
